import './full-supply-cost-receipt-amounts.scss'

import cx from 'classnames'
import { useTranslation } from 'react-i18next'
import {
  Typography,
} from '@mui/material'

import {
  formatRub,
  formatUsd,
} from './calculation-money'
import {
  formatAmountDelta,
} from '../proposal-service-line-utils'

function formatReceiptLine(raw: string, currencyCode: string): string {
  if (currencyCode === 'RUB') {
    return `≈ ${formatRub({ value: raw, fractionDigits: 2 })}`
  }
  return formatUsd({ value: raw, fractionDigits: 2 }) ?? '—'
}

const FullSupplyCostReceiptAmounts = ({
  alignment = 'right',
  comparison,
  currencyCode = 'USD',
  emphasis,
  deltaBelow = false,
}: FullSupplyCostReceiptAmountsProps) => {
  const { i18n } = useTranslation()
  const after = comparison?.after?.trim() || ''
  const delta = formatAmountDelta(comparison?.delta, currencyCode)

  if (!after && !delta) {
    return (
      <Typography variant='body2' className='full-supply-cost-receipt-amounts__empty'>
        —
      </Typography>
    )
  }

  const formattedDelta = delta ? new Intl.NumberFormat(i18n.language, {
    signDisplay: 'always',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(comparison?.delta)) : ''

  const deltaLabel = delta && (
    <Typography
      component='span'
      variant='caption'
      className='full-supply-cost-receipt-amounts__delta'
      sx={{
        color: delta.direction === 'up' ? 'error.main' : 'success.main',
        fontSize: 11,
        lineHeight: '16px',
      }}
    >
      {`(${formattedDelta} ${currencyCode})`}
    </Typography>
  )

  return (
    <div
      className={cx(
        'full-supply-cost-receipt-amounts',
        alignment === 'left' && 'full-supply-cost-receipt-amounts_left',
        emphasis && 'full-supply-cost-receipt-amounts_emphasis',
      )}
    >
      <Typography
        variant='inherit'
        component='div'
        className='full-supply-cost-receipt-amounts__after'
        sx={{
          color: 'inherit',
          fontWeight: 400,
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: alignment === 'left' ? 'flex-start' : 'flex-end',
          gap: '4px',
        }}
      >
        {after ? formatReceiptLine(after, currencyCode) : '—'}
        {!deltaBelow && deltaLabel}
      </Typography>
      {deltaBelow && deltaLabel}
    </div>
  )
}

export default FullSupplyCostReceiptAmounts
